import { composeReducer } from 'redux-compose-reducer';

const initialState = {
  psychics: [],
  statistic: {},
  cohortSearch: null,
  user: null,
  managers: [],
  managerStats: {},
  managersStats: {},
  envStats: {},
  dailyStats: {},
  managersConversationStats: {}
};

function getAllPsychicsInfoAndStatitstic(state, action) {
  return {
    ...state,
    psychics: action.data.data,
    statistic: action.data.statistic
  };
}

function getUserByEmail(state, action) {
  return {
    ...state,
    user: action.data
  };
}

function updateUser(state, action) {
  return {
    ...state,
    user: action.data
  };
}

function getUserReportsByEmail(state, action) {
  return {
    ...state,
    user: action.data
  };
}

function getCohortSearch(state, action) {
  return {
    ...state,
    cohortSearch: action.data
  };
}

function getManagers(state, action) {
  return {
    ...state,
    managers: action.data
  };
}

function setSingleManagerStats(state, action) {
  return {
    ...state,
    managerStats: action.data
  };
}

function setManagersStats(state, action) {
  return {
    ...state,
    managersStats: action.data
  };
}

function setEnvStats(state, action) {
  return {
    ...state,
    envStats: action.data
  };
}

function setDailyStats(state, action) {
  return {
    ...state,
    dailyStats: action.data
  };
}

export default composeReducer('superuser', {
  getAllPsychicsInfoAndStatitstic,
  getUserByEmail,
  updateUser,
  getUserReportsByEmail,
  getCohortSearch,
  getManagers,
  setSingleManagerStats,
  setManagersStats,
  setEnvStats,
  setDailyStats
}, initialState);



// WEBPACK FOOTER //
// ./src/reducers/superuser.js